import React from 'react';

import DatePicker, { registerLocale } from 'react-datepicker';
import ru from 'date-fns/locale/ru';

registerLocale('ru', ru);

/**
 * PROPS
 * value = string
 * options = array of objects {value: string, label: string}
 * label = string
 * onChange(value) = func
 */

const DateInput = props => {
  return (
    // eslint-disable-next-line
    <label className="select" style={{ cursor: 'pointer' }}>
      <div className="select__label">{props.label ? props.label : ''}</div>
      <DatePicker
        selected={props.value}
        dateFormat="dd.MM.yyyy"
        locale="ru"
        onChange={val => props.onChange(val)}
      />
    </label>
  );
};

export default DateInput;
